<template>
    <b-modal id="metodos-pago-nuevo" title="Agregar método de pago">
        <div id="card-element"></div>
        <div id="card-errors" role="alert"></div>
        <template #modal-footer>
            <b-button variant="info" v-if="!isProcessing">
                Cancelar
            </b-button>
            <b-button variant="primary" @click="handleSubmit" :disabled="isProcessing">
                <span v-if="!isProcessing">Agregar</span>
                <span v-else>Procesando...</span>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from 'axios';
import { BModal } from 'bootstrap-vue';
import {notify} from '../../../utils'
import stripeObj from '../daniel/stripeHandler'

export default {
    name: 'metodosPagoNuevo',
    components: {
        BModal
    },
    data() {
        return {
            stripe: null,
            stripeElements: null,
            stripeCardElement: null,
            stripePaymentMethod: null,
            isProcessing: false
        };
    },
    methods: {
        open() {
            if (!this.stripe)
                this.stripe = stripeObj.initialize();
            this.$bvModal.show('metodos-pago-nuevo');
            this.$nextTick(() => {
                // Crear instancia de Elements solo después de que el modal sea visible
                this.stripeElements = this.stripe.elements();

                // Crear el elemento de tarjeta
                this.stripeCardElement = this.stripeElements.create('card', {style: stripeObj.style});
                // this.stripeCardElement = this.stripeElements.create('card', {
                //     style: {
                //         base: {
                //             fontSize: '16px',
                //             color: '#32325d',
                //         },
                //     },
                // });

                // Montar el elemento en el DOM
                this.stripeCardElement.mount('#card-element');

                // Manejar errores de validación en tiempo real
                this.stripeCardElement.addEventListener('change', (event) => {
                    const displayError = document.getElementById('card-errors');
                    if (event.error) {
                        displayError.textContent = event.error.message;
                    } else {
                        displayError.textContent = '';
                    }
                });
            });
        },
        async handleSubmit($event) {
            if(this.isProcessing)
                return true;
            this.isProcessing = true;
            try {
                const pm = await this.processPMObj();
                if(!pm)
                    throw 'Token no recibido';
                const response = await axios.post('/stripeutils/addpm', {
                    payment_method_id: pm.id
                });

                if (response.status) {
                    this.$emit('paymentAdded', response);
                    this.$bvModal.hide('metodos-pago-nuevo');
                    notify('Método de pago agregado exitosamente', 'success')
                } else {
                    throw response.msg || 'Error al agregar el método de pago';
                }
            } catch (e) {
                console.error(e);
                notify(e)
            }
            this.isProcessing = false;
        },
        async processPMObj() {
            let paymentMethod = null;
            const result = await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.stripeCardElement,
            })
            if (result.error) {
                // Handle error
                console.warn(result.error)
                throw result.error.message;
            } else {
                // PaymentMethod created successfully
                console.log(result.paymentMethod);
                paymentMethod = result.paymentMethod;
                // Send paymentMethod.id to your server
            }
            return paymentMethod;
        },
    },
    beforeDestroy() {
        // Limpiar el elemento de tarjeta cuando el componente se destruye
        if (this.stripeCardElement) {
            this.stripeCardElement.unmount();
        }
    }
};
</script>

<style>
#card-element {
    margin-top: 20px;
    margin-bottom: 20px;
}

#card-errors {
    color: #fa755a;
    margin-top: 10px;
}
</style>